import FileSize from "../../../../components/commonComponent/FileSize";
import React, { useState, useEffect } from "react";
import { PdfPreviewModal } from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import artisansImage from "../../../../assets/images/artisans.svg";
import cataloguePdf from "../../../../assets/tenders/resource/catalogue.pdf";

const marketingOpportunities = [
  {
    serial: 1,
    organisation:
      "Central Cottage Industries Emporium, A Govt. of India Undertaking, Ministry of Textiles",
    websiteLabel: "cottageemporium.in",
    websiteHref: "https://cottageemporium.in/",
    actions: [{ label: "Online Form", href: "https://cottageemporium.in/" }],
  },
  {
    serial: 2,
    organisation: "One District One Product, Deptt. of MSME & Export Promotion, U.P.",
    websiteLabel: "odopup.in",
    websiteHref: "https://odopup.in/",
    actions: [{ label: "Online Form", href: "https://odopup.in/" }],
  },
  {
    serial: 3,
    organisation: "Khadi India",
    websiteLabel: "khadiindia.gov.in",
    websiteHref: "https://khadiindia.gov.in/",
    actions: [{ label: "Register here", href: "https://khadiindia.gov.in/" }],
  },
  {
    serial: 4,
    organisation: "India HandloomBrand",
    websiteLabel: "indiahandloombrand.gov.in",
    websiteHref: "https://indiahandloombrand.gov.in/",
    actions: [
      { label: "Register here", href: "https://indiahandloombrand.gov.in/" },
    ],
  },
  {
    serial: 5,
    organisation: "Amazon Karigar",
    websiteLabel: "sell.amazon.in",
    websiteHref: "https://sell.amazon.in/",
    actions: [{ label: "Register Here", href: "https://sell.amazon.in/" }],
  },
  {
    serial: 6,
    organisation: "Shopify",
    websiteLabel: "shopify.com",
    websiteHref: "https://www.shopify.com/",
    actions: [{ label: "Register Here", href: "https://www.shopify.com/" }],
  },
  {
    serial: 7,
    organisation: "Flipkart",
    websiteLabel: "seller.flipkart.com",
    websiteHref: "https://seller.flipkart.com/",
    actions: [
      { label: "Register Here", href: "https://seller.flipkart.com/" },
      { label: "User Guide", href: "https://seller.flipkart.com/" },
    ],
  },
  {
    serial: 8,
    organisation: "iCraft",
    websiteLabel: "icraftgifts.com",
    websiteHref: "https://icraftgifts.com/",
    actions: [{ label: "Register Here", href: "https://icraftgifts.com/" }],
  },
  {
    serial: 9,
    organisation: "Folksy",
    websiteLabel: "folksy.com",
    websiteHref: "https://folksy.com/",
    actions: [{ label: "Register Here", href: "https://folksy.com/" }],
  },
  {
    serial: 10,
    organisation: "ebay",
    websiteLabel: "ebay.com",
    websiteHref: "https://www.ebay.com/",
    actions: [
      { label: "Register Here", href: "https://www.ebay.com/" },
      { label: "User Guide", href: "https://www.ebay.com/" },
    ],
  },
  {
    serial: 11,
    organisation: "Etsy",
    websiteLabel: "etsy.com",
    websiteHref: "https://www.etsy.com/",
    actions: [
      { label: "Register Here", href: "https://www.etsy.com/" },
      { label: "User Guide", href: "https://www.etsy.com/" },
    ],
  },
];

const ExternalLink = ({ href, children, label }) => (
  <a
    href={href}
    aria-label={`${label} (opens in a new tab)`}
    target="_blank"
    rel="noopener noreferrer"
    className="font-medium text-[#16376c] underline underline-offset-2 transition-colors hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
  >
    {children}
  </a>
);

const catalogueDocument = {
  title: "Catalogue of Crafts by Minority Artisans",
  fileName: "catalogue.pdf",
  href: cataloguePdf,
};

const MarketingOpportunitiesForMinorityArtisans = () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash === "#hello-artisans") {
        setTimeout(() => {
          document.getElementById("hello-artisans")?.scrollIntoView({ behavior: "smooth" });
        }, 150);
      } else if (hash === "#meet-our-artisans") {
        setTimeout(() => {
          document.getElementById("meet-our-artisans")?.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    };

    handleHashScroll();
    window.addEventListener("hashchange", handleHashScroll);
    return () => window.removeEventListener("hashchange", handleHashScroll);
  }, []);

  const handleOpenCatalogue = () => {
    setSelectedDocument(catalogueDocument);
  };

  const handleCloseCatalogue = () => {
    setSelectedDocument(null);
  };

  return (
    <section className="min-w-0 flex-1 space-y-2">
      <div id="hello-artisans">
        <h2 className="mb-3 text-[20px] font-bold text-[#005856]">
          Hello Artisans! Want to sell your products online?
        </h2>
        <p className="mb-4 text-[14px] font-medium leading-7 text-[#16376c]">
          NMDFC has compiled the available opportunities for marketing of
          products of artisans belonging to minority communities, including
          through online channels. The artisans interested in selling their
          product, may register to the below listed organizations for display &
          online sale of their products:
        </p>

        <div className="overflow-hidden rounded-xl border border-[#d9e4ef]">
          <div className="overflow-x-auto">
            <table
              className="w-full table-fixed border-collapse text-[13px] text-[#001b33]"
              style={{ minWidth: "860px" }}
            >
              <colgroup>
                <col className="w-[72px]" />
                <col />
                <col className="w-[190px]" />
                <col className="w-[210px]" />
              </colgroup>
              <thead>
                <tr className="bg-[#dce9fb] text-left text-[14px] font-bold text-[#001b33]">
                  <th className="px-4 py-3">S.No.</th>
                  <th className="px-4 py-3">Name of Organisation</th>
                  <th className="px-4 py-3">Website</th>
                  <th className="px-4 py-3">Online Form/Register Link</th>
                </tr>
              </thead>
              <tbody>
                {marketingOpportunities.map((item, index) => (
                  <tr
                    key={item.serial}
                    className={`border-b border-[#d9e4ef] last:border-b-0 ${
                      index % 2 === 0 ? "bg-[#fbfdff]" : "bg-[#f5f9fc]"
                    }`}
                  >
                    <td className="px-4 py-2.5 align-middle font-medium">
                      {String(item.serial).padStart(2, "0")}
                    </td>
                    <td className="px-4 py-2.5 align-middle font-medium">
                      {item.organisation}
                    </td>
                    <td className="px-4 py-2.5 align-middle">
                      <ExternalLink href={item.websiteHref} label={`${item.websiteLabel} — ${item.organisation} website`}>
                        {item.websiteLabel}
                      </ExternalLink>
                    </td>
                    <td className="px-4 py-2.5 align-middle">
                      <div className="flex flex-wrap gap-x-2 gap-y-1">
                        {item.actions.map((action) => (
                          <ExternalLink key={action.label} href={action.href} label={`${action.label} — ${item.organisation}`}>
                            {action.label}
                          </ExternalLink>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div id="meet-our-artisans" className="rounded-2xl bg-white p-4 shadow-[0_10px_30px_rgba(0,0,0,0.04)] sm:p-5">
        <h2 className="mb-3 text-[18px] font-bold text-[#005856] underline underline-offset-2">
          Meet Our Artisans & Their Work!
        </h2>
        <button
          type="button"
          onClick={handleOpenCatalogue}
          aria-label="Open catalogue of crafts by minority artisans"
          className="block w-full overflow-hidden rounded-lg border border-[#d9e4ef] bg-white p-0 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
        >
          <img
            src={artisansImage}
            alt="Catalogue of crafts by minority artisans"
            className="block h-auto w-full"
          /><FileSize href={catalogueDocument.href} fileName={catalogueDocument.fileName} />


        </button>
      </div>

      <p className="px-1 text-[13px] font-bold text-[#16376c]">
        Link of catalogue -{" "}
        <button
          type="button"
          onClick={handleOpenCatalogue}
          className="bg-transparent p-0 font-bold text-[#16376c] underline underline-offset-2 transition-colors hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
        >
          View catalogue of crafts by minority artisans<FileSize href={catalogueDocument.href} fileName={catalogueDocument.fileName} />


        </button>
      </p>

      {selectedDocument && (
        <PdfPreviewModal
          pdfDocument={selectedDocument}
          onClose={handleCloseCatalogue}
        />
      )}
    </section>
  );
};

export default MarketingOpportunitiesForMinorityArtisans;
